module.exports = __webpack_public_path__ + "img/news-07.ee153e75.jpg";